import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

const routeGuard = (to, from, next) => {
  const packageType = to.path.split('/').includes('package') ? 'package' : 'tour'
  if (model.params.packageType !== packageType || model.distribution !== to.params.DistributionChannel) {
    model.resetData()
    model.params.packageType = packageType
    model.distribution = to.params.DistributionChannel
    model.params.distribution = to.params.DistributionChannel
    model.initDataLoaded = false
  }
  if (!model.initDataLoaded) model.init().then(res => next())
  else next()
}

const packageViews = {
  path: 'package',
  component: homeView,
  name: 'Private/Package',
  redirect: { name: 'Private/Package/Search', params: { DistributionChannel: 2 } },
  children: [
    {
      path: 'search/:DistributionChannel',
      name: 'Private/Package/Search',
      component: searchView
    },
    {
      path: 'book/:DistributionChannel/:Result/:Package/:Category/:Meal',
      name: 'Private/Package/Book',
      component: bookView
    }
  ],
  beforeEnter: routeGuard
}

const tourViews = {
  path: 'tour',
  component: homeView,
  name: 'Private/Tour',
  redirect: { name: 'Private/Tour/Search' },
  children: [
    {
      path: 'search/:DistributionChannel?',
      name: 'Private/Tour/Search',
      component: searchView
    },
    {
      path: 'book/:DistributionChannel?/:Result/:Package/:Category/:Meal',
      name: 'Private/Tour/Book',
      component: bookView
    }
  ],
  beforeEnter: routeGuard
}

export {
  routeGuard,
  packageViews,
  tourViews
}
